import React, { useState, useEffect } from 'react';
import { setAuthToken } from '../util/session';
import { fetchBranches } from '../util/branches'
import { submitScreeningForm } from '../util/screeningLogs'

const ScreeningForm = (props) => {
    const [formInput, setFormInput] = useState({
        option1: false,
        option2: false,
        option3: false,
        option4: false,
        option5: false,
        name: "",
        branch: "",
        date: "",
        submitted: false,
        authenticated: false,
        passwordInput: "",
        error: "",
        idx: -1
    })
    const [branches, setBranches] = useState(null)
    const [submitError, setSubmitError] = useState(null)
    let {
        option1,
        option2,
        option3,
        option4,
        option5,
        name,
        branch,
        date,
        submitted,
        authenticated,
        passwordInput,
        error,
        idx
    } = formInput

    const dateToday = () => {
        var now = new Date();
        var month = (now.getMonth() + 1);               
        var day = now.getDate();
        if (month < 10) 
            month = "0" + month;
        if (day < 10) 
            day = "0" + day;
        var today = now.getFullYear() + '-' + month + '-' + day;
        return today
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        const errors = ["Sorry, that's not it", "Still not it", "Try again", "C'mon, do you even work here?"]
        idx = (idx+1) % errors.length
        if (passwordInput.toLowerCase() === 'covid') {
          setFormInput({...formInput, authenticated: true})
        } else {
          setFormInput({...formInput, error: errors[idx], passwordInput: '', idx: idx})
        }
    }
    
    const sendForm = (e) => {
        e.preventDefault()

        if (!option1 && !option2 && !option3 && !option4 && !option5) {
            alert('Please fill out form')
            return
        }

        if (name === "") {
            alert('Please fill out name')
            return
        }

        if (branch === "") {
            alert('Please select branch location')
            return
        }
    
        // let email = new Mailer(this.state)
        // email.send()
        //   .then(() => this.setState({
        //     option1: false,
        //     option2: false,
        //     option3: false,
        //     option4: false,
        //     option5: false,
        //     name: "",
        //     branch: "",
        //     date: this.dateToday(),
        //     submitted: true
        //   }))

        submitScreeningForm({name, branch, option1, option2, option3, option4, option5})
            .then(res => {
                setFormInput({
                    ...formInput,
                    option1: false,
                    option2: false,
                    option3: false,
                    option4: false,
                    option5: false,
                    name: "",
                    branch: "",
                    date: dateToday(),
                    submitted: true
                })
                window.scrollTo(0, document.documentElement.offsetHeight)
                setSubmitError(null)
            })
            .catch(err => setSubmitError(err.response.data.err))

      }

    useEffect(() => {
        setFormInput({...formInput, date: dateToday()})
        fetchBranches().then(branches => setBranches(branches.data))
    }, [])

    if (!authenticated) return (
        <form className='auth-container' onSubmit={(e) => handleSubmit(e)}>
            <div style={{fontSize: "100px"}}>
                <i className="fas fa-lock"></i>
            </div>
            <h1>This content is protected.</h1>
            <p>To view, please enter password 😎</p>
            <input value={passwordInput} className="password-input" type='password' placeholder='Password' onChange={(e) => setFormInput({...formInput, passwordInput: e.target.value})}/>
            <p style={{color: "red", marginTop: "10px"}}>{error}</p>
            <button type='submit'>Unlock</button>
        </form>
    )

    if (submitted) {
        return <div class="alert alert-success" role="alert">Thank you, submitted successfully!</div>
    }

    branches.sort((a,b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
    })

    return (
        <form className="form-container" onSubmit={(e) => sendForm(e)}>
          
              <h1>COVID-19 Screening Form</h1>
              <p>In accordance with applicable mandatory State and local Health Department Safety Orders and guidelines from the United States Centers for Disease Control and Prevention (CDC), we are requiring everyone to complete this questionnaire as a condition of entering the facility. This notice is being provided in accordance with the California Consumer Privacy Act("CCPA"). You are required to fill out this form inside the entrance of the office for each shift. Please complete the form below and it will automatically be sent to aia@exactstaff.com each day prior to going to your work area.</p>
  
          <div className="form">
              <div className="reason">
                  <input type="checkbox" checked={option1} onChange={() => setFormInput({...formInput, option1: !option1})}/>
                  <label>Has a fever(&gt;100.4) AND signs/symptoms of acute COVID-19 illness (e.g chills, cough, difficulty breathing, sudden loss of taste or smell, and other symptoms found at <a href="https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html">https://www.cdc.gov/coronavirus/2019-ncov/symptoms-testing/symptoms.html</a>)</label>
              </div>
              <div className="reason">
                  <input type="checkbox" checked={option2} onChange={() => setFormInput({...formInput, option2: !option2})}/>
                  <label>Has had close contact with someone with confirmed or suspected COVID-19 within the last 14 days</label>
              </div>
              <div className="reason">
                  <input type="checkbox" checked={option3} onChange={() => setFormInput({...formInput, option3: !option3})}/>
                  <label>Are isolating or quarantining because you may have been exposed to a person with COVID-19</label>
              </div>
              <div className="reason">
                  <input type="checkbox" checked={option4} onChange={() => setFormInput({...formInput, option4: !option4})}/>
                  <label>Are currently waiting on the results of a Covid-19 test</label>
              </div>
              <div className="reason">
                  <input type="checkbox" checked={option5} onChange={() => setFormInput({...formInput, option5: !option5})}/>
                  <label>Does not meet any of the above criteria</label>
              </div>
          </div>
          {/* <input className='form-input' type="text" value={name} placeholder="Name" onChange={(e) => setFormInput({...formInput, name: e.target.value})}/><br/> */}
          <input class="form-control form-control-lg" type="text" placeholder="Name" value={name} onChange={(e) => setFormInput({...formInput, name: e.target.value})} />
          {/* <input className='form-input' type="text" value={branch} placeholder="Branch Location" onChange={(e) => setFormInput({...formInput, branch: e.target.value})}/><br/> */}
          <select class="form-control form-control-lg" onChange={(e) => setFormInput({...formInput, branch: e.target.value})}>
            <option disabled selected>--Select branch--</option>
            {branches ? branches.map(branch => (
                  <option key={branch.id} value={branch._id}>{branch.name}</option>
              )) : null}
          </select>
          {/* <input className='form-input' type="date" value={date} onChange={(e) => setFormInput({...formInput, date: e.target.value})}/><br/> */}
          {/* <button type='submit' className='button'>Submit</button><br/> */}
          <button type="submit" className="btn btn-primary btn-lg btn-block">Submit</button>
          {/* {submitted ? <div class="alert alert-success" role="alert">Thank you, submitted successfully!</div> : null} */}
          {/* {submitError ? <div class="alert alert-danger" role="alert">{submitError}</div> : null} */}
        </form>
      )
}

export default ScreeningForm